import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Fade } from 'react-slideshow-image';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ChatIcon from '@mui/icons-material/Chat';
const fadeImages = [
  {
    url: 'https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    caption: 'Slide 1'
  },
  {
    url: 'https://images.unsplash.com/photo-1506710507565-203b9f24669b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1536&q=80',
    caption: 'Slide 2'
  },
  {
    url: 'https://images.unsplash.com/photo-1536987333706-fc9adfb10d91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    caption: 'Slide 3'
  },
];

function MobileMarketDetailsBuyer() {
  const navigate = useNavigate()
  return (
    <div className='mainwrapperView'>
      <div className="drawerFixedPatch"></div>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileMarketPlaceBuyer")}
        />
        <h1>Product Details</h1>
      </div>
      <div className='ListingView'>
      <div className="famDetailsListInrMob">
      <div className="slide-container">
      <Fade>
        {fadeImages.map((fadeImage, index) => (
          <div key={index}>
            <img style={{ width: '100%' }} src={fadeImage.url} alt='altimg'/>
          </div>
        ))}
      </Fade>
    </div>
    <div className='RatingView'>
      <p className='RatingTxt'>Rating:</p>
      <div>
        <StarBorderIcon sx={{fontSize:20, color:'#d18f00'}}/>
        <StarBorderIcon sx={{fontSize:20, color:'#d18f00'}}/>
        <StarBorderIcon sx={{fontSize:20, color:'#d18f00'}}/>
        <StarBorderIcon sx={{fontSize:20, color:'#d18f00'}}/>
        <StarBorderIcon sx={{fontSize:20, color:'#d18f00'}}/>
      </div>
    </div>
    <div className='ListDateView'>
      <p className='ListDateListTxt'>Listed Date:</p>
      <p className='ListDateTimeTxt'>05/02/2023 10:25 am</p>
    </div>
    <div className='ListPriceView'>
      <p className='ListPriceTxt'>Price: <CurrencyRupeeIcon sx={{fontSize:16}}/> 777.00</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Title :</p>
      <p className='ListNameTxt'>Name</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Contact :</p>
      <p className='ListNameTxt'>0124578</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Category :</p>
      <p className='ListNameTxt'>Women</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Condition :</p>
      <p className='ListNameTxt'>New</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Description :</p>
      <p className='ListNameTxt'>Test Test Test</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Address :</p>
      <p className='ListNameTxt'>Nashik</p>
    </div>
    <div className='chatSellerBtnView' onClick={()=>navigate('/MobileChatScreen')}>
      <p className='ListPriceTxt'> <ChatIcon /> Chat with Seller</p>
    </div>
    </div>
      </div>
    </div>
  )
}

export default MobileMarketDetailsBuyer